import Icon from './Icon';

/** Inline validation message shown under a form field. */
export default function FieldError({ id, children }) {
  if (!children) return null;
  return (
    <p id={id} role="alert" className="mt-1.5 flex items-start gap-1 text-xs text-error">
      <Icon name="error" size={14} className="mt-px" />
      {children}
    </p>
  );
}
